import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { HttpTypes } from "@medusajs/types";
import { Text } from "@medusajs/ui";
type LineItemOptionsProps = {
  variant: HttpTypes.StoreProductVariant | undefined;
  "data-testid"?: string;
  "data-value"?: HttpTypes.StoreProductVariant;
};
const LineItemOptions = t0 => {
  const $ = _c(7);
  const {
    variant,
    "data-testid": dataTestid,
    "data-value": dataValue
  } = t0;
  const t = useTranslations("store");
  let t1;
  if ($[0] !== t) {
    t1 = t("Variant");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = variant?.title;
  let t3;
  if ($[2] !== dataTestid || $[3] !== dataValue || $[4] !== t1 || $[5] !== t2) {
    t3 = <Text data-testid={dataTestid} data-value={dataValue} className="inline-block txt-medium text-ui-fg-subtle w-full overflow-hidden text-ellipsis">{t1}: {t2}</Text>;
    $[2] = dataTestid;
    $[3] = dataValue;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default LineItemOptions;